import { useEffect } from 'react';

import type { ReadonlyURLSearchParams } from 'next/navigation';
import { usePathname, useSearchParams } from 'next/navigation';

import { useEffectEvent } from './useEventEffect';

type onRouteChangeCallback = (params: {
  pathname: string;
  searchParams: ReadonlyURLSearchParams;
}) => void;

export function useOnRouteChange(callback: onRouteChangeCallback) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const callbackEvent = useEffectEvent(callback);

  useEffect(() => {
    callbackEvent({ pathname, searchParams });
  }, [callbackEvent, pathname, searchParams]);
}
